import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const toastUpdate = (toastId: string, type: "info" | "success" | "warning" | "error" | "default", time: number,  text: string) => {
    return toast.update(toastId, { type: type , autoClose: time, render: text })
}

export const toastCreate = (toastId: string, type: "info" | "success" | "warning" | "error" | "default", time: number,  text: string) => {
    toast(text, {type: type, toastId: toastId , autoClose: time})
}